/**
 * Item schema terms
 *
 * @package lib-components
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

export const item = {
	spacing: {
		label: "schema:item.spacing#label",
		description: "schema:item.spacing#description"
	}
};
